import React from "react";
import { useMap } from "react-leaflet";
import "../css/mapPage.css";
import "../css/GCPillButton.css";
import { useLanguage } from "../components/Language.js";

function RecentreMapOnPins({lat,long}){
    const map = useMap();

    const {language} = useLanguage();

    const translations = {
        en: {
            allEvents: "Back to all events view",
               
        },

        gd: {
            allEvents: "Air ais gu sealladh thachartasan uile",
            
        },
    };

    const handleRecentreMap = () => {
        map.flyTo([lat, long], 13)

    };

    return(
        <div>
            <button onClick = {handleRecentreMap} className="location-load-buttons return-centre-button GCPillbutton">{translations[language].allEvents}</button>
        </div>
    );
}

export default RecentreMapOnPins; 